import React from 'react';
import grey from '@material-ui/core/colors/grey';
import { makeStyles } from '@material-ui/core/styles';
import { PeriodSelector, PeriodDropdown } from '~/modules/common/components';
import StickyHeader from '~/modules/common/components/StickyHeader/StickyHeader';
import { useHasFeatureFlag } from '~/modules/common/hooks';
import PeriodStartDateSelector from '~/modules/common/charts/dashboard/PeriodStartDateSelector';
import { useResourceOverviewToolbarContext } from '../../hooks';

const usePeriodDropdownStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(0, 2, 0, 0)
  }
}));

const useStyles = makeStyles(() => ({
  spacer: {
    flexGrow: 1,
    flexShrink: 1
  }
}));

export const useStickyHeaderStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(1)
  },
  toolbar: {
    backgroundColor: grey[50]
  }
}));

const usePeriodSelectorStyles = makeStyles(theme => ({
  date: {
    [theme.breakpoints.down('xs')]: {
      display: 'inline-flex'
    }
  }
}));

export const ResourcingOverviewToolbar = () => {
  const {
    dateRange,
    periodScale,
    setScale,
    setNextPeriod,
    setPreviousPeriod,
    setDate
  } = useResourceOverviewToolbarContext();

  const isRmp2025Q3Enhancements = useHasFeatureFlag({
    featureFlag: 'isRmp2025Q3Enhancements'
  });

  const classes = useStyles();
  const stickyHeaderStyles = useStickyHeaderStyles();
  const periodSelectorClasses = usePeriodSelectorStyles();
  const periodClasses = usePeriodDropdownStyles();
  const PeriodSelectorComponent = isRmp2025Q3Enhancements
    ? PeriodStartDateSelector
    : PeriodSelector;

  return (
    <StickyHeader level={2} classes={stickyHeaderStyles}>
      <PeriodSelectorComponent
        classes={isRmp2025Q3Enhancements ? null : periodSelectorClasses}
        onPreviousClick={setPreviousPeriod}
        onNextClick={setNextPeriod}
        dateRange={dateRange}
        scale={periodScale}
        setDate={setDate}
      />
      <div className={classes.spacer} />
      <PeriodDropdown
        classes={periodClasses}
        value={periodScale}
        onChange={setScale}
        showYears={false}
      />
    </StickyHeader>
  );
};

export default ResourcingOverviewToolbar;
